function CndtIcon({ className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 100 100"
      fill="none"
      stroke="currentColor"
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect x="15" y="15" width="22" height="22" rx="4" />
      <path d="M21 26 L25 30 L32 20" strokeWidth="4" />
      <rect x="15" y="44" width="22" height="22" rx="4" />
      <path d="M21 55 L25 59 L32 49" strokeWidth="4" />
      <rect x="15" y="73" width="22" height="22" rx="4" />
      <path d="M21 84 L25 88 L32 78" strokeWidth="4" />
      <path d="M52 75 L85 42 c2.5-2.5 2.5-6.5 0-9 l-8-8 c-2.5-2.5-6.5-2.5-9 0 L40 57 v18 h12 z" />
      <path d="M68 30 L78 40" strokeWidth="4" />
    </svg>
  );
}

function ExerciseLawIcon({ className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 100 100"
      fill="none"
      stroke="currentColor"
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M12 30 h26" strokeWidth="5.5" />
      <path d="M25 30 v40 M18 70 h14" />
      <path d="M12 30 L8 45 h8 Z" strokeWidth="4" />
      <path d="M38 30 L34 45 h8 Z" strokeWidth="4" />
      <path d="M70 20 c-7 0-11 5-11 12 s4 10 11 10 11-3 11-10-4-12-11-12 Z" />
      <circle cx="65" cy="32" r="3.5" strokeWidth="3" />
      <circle cx="75" cy="32" r="3.5" strokeWidth="3" />
      <path d="M68.5 32 h3" />
      <path d="M52 75 v-5 c0-8 7-14 16-15 h4 c9 1 16 7 16 15 v5" />
      <path d="M64 55 L70 67 L76 55" strokeWidth="4" />
      <path d="M68 67 l-2.5 10 h9 L72 67 Z" fill="currentColor" strokeWidth="2" />
    </svg>
  );
}

function ProcessProgressIcon({ className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 100 100"
      fill="none"
      stroke="currentColor"
      strokeWidth="6.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M60 10 H22 c-4.4 0-8 3.6-8 8 v64 c0 4.4 3.6 8 8 8 h56 c4.4 0 8-3.6 8-8 V38 Z" />
      <path d="M60 10 v28 h26" />
      <circle cx="42" cy="58" r="10" />
      <path d="m50 66 14 14" strokeWidth="7" />
      <path d="M30 32 h22 M30 45 h10" strokeWidth="6" />
    </svg>
  );
}

function CaseDistributionIcon({ className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 100 100"
      fill="none"
      stroke="currentColor"
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M30 12 h44 L90 28 v56 c0 3.3-2.7 6-6 6 H30 c-3.3 0-6-2.7-6-6 V18 c0-3.3 2.7-6 6-6 Z" />
      <path d="M74 12 v16 h16" strokeWidth="5.5" />
      <path d="M40 35 h30 M40 48 h36 M40 61 h18" strokeWidth="4.5" />
      <path
        d="M10 78 C10 70 18 69 25 69 H30 v19 H25 C18 88 10 86 10 78 Z"
        fill="currentColor"
        fillOpacity="0.1"
        strokeWidth="4"
      />
      <path d="M24 69 c0-5.5 4-9 8-9 s8 3.5 8 9" strokeWidth="4.5" />
    </svg>
  );
}

function ArchivedProcessIcon({ className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 100 100"
      fill="none"
      stroke="currentColor"
      strokeWidth="6.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M60 10 H22 c-4.4 0-8 3.6-8 8 v64 c0 4.4 3.6 8 8 8 h56 c4.4 0 8-3.6 8-8 V38 Z" />
      <path d="M60 10 v28 h26" />
      <rect x="30" y="44" width="26" height="26" rx="4" />
      <path d="m37 57 5 5 10-10" />
      <path d="M30 32 h22" strokeWidth="6" />
    </svg>
  );
}

function OtherCertificatesIcon({ className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 100 100"
      fill="none"
      stroke="currentColor"
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect x="15" y="12" width="70" height="76" rx="8" />
      <rect x="23" y="20" width="54" height="60" rx="4" strokeWidth="2.5" strokeDasharray="4 3" />
      <path d="M34 35 h32 M34 47 h32 M34 59 h22" strokeWidth="4.5" />
      <circle cx="62" cy="64" r="9" strokeWidth="5.5" />
      <path d="M58 72.5 l-3 11 7-4.5 7 4.5-3-11" strokeWidth="4" />
      <path d="M62 59.5 v9 M57.5 64 h9" strokeWidth="2.5" />
    </svg>
  );
}

export function ServiceIcon({ serviceId, className }) {
  if (serviceId === "emitir-certidao-andamento") {
    return <ProcessProgressIcon className={className} />;
  }
  if (serviceId === "validar-certidao-andamento") {
    return <CndtIcon className={className} />;
  }
  if (serviceId === "emitir-certidao-arquivados") {
    return <ArchivedProcessIcon className={className} />;
  }
  if (serviceId === "validar-certidao-arquivados") {
    return <CaseDistributionIcon className={className} />;
  }
  if (serviceId === "emitir-exercicio-advocacia") {
    return <ExerciseLawIcon className={className} />;
  }
  return <OtherCertificatesIcon className={className} />;
}
